import * as React from "react";
const SvgFiRrWheat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wheat_svg__a)">
      <path
        fill="#062147"
        d="M21.833 7.793c1.293-1.293 1.878-3.666 2.142-5.427A2.07 2.07 0 0 0 21.632.024c-1.984.331-4.7.912-5.865 2.712-2.166-3.775-4.827-.624-5.59 2.416-2.315-.645-3.332 2.018-4 4C3.717 8.322 2.093 12.29 2 14.5a7.63 7.63 0 0 0 1.65 4.437L.29 22.293a1 1 0 0 0 1.414 1.414l3.356-3.356a7.63 7.63 0 0 0 4.44 1.65c2.168-.08 6.25-1.765 5.37-4.182 1.926-.654 4.71-1.738 4-4 3.05-.794 6.212-3.416 2.389-5.589q.312-.185.572-.437M17.618 3.58A7.87 7.87 0 0 1 22 2.07c-.645 3.757-1.288 5.265-4.97 4.9-.095-1.259.021-2.823.588-3.39M13.493 3c1.128 1.215 2.137 3.85.954 5.144l-1.523 1.52A7.9 7.9 0 0 0 12 7.126 6.06 6.06 0 0 1 13.493 3m-4 4c1.127 1.215 2.136 3.848.954 5.144l-1.524 1.52A7.9 7.9 0 0 0 8 11.126 6.05 6.05 0 0 1 9.492 7m-4 4c1.126 1.214 2.135 3.848.954 5.143L5.08 17.505A4.95 4.95 0 0 1 5.492 11M9.5 20a5.5 5.5 0 0 1-3.005-1.08l1.365-1.366c1.3-1.184 3.93-.168 5.147.938A6.2 6.2 0 0 1 9.5 20m4-4c-.133 0-.553-.01-.63 0a7.9 7.9 0 0 0-2.532-.922l1.524-1.523c1.293-1.184 3.928-.167 5.144.938A6.2 6.2 0 0 1 13.502 16m4-4c-.134 0-.552-.01-.63 0a7.9 7.9 0 0 0-2.533-.923l1.524-1.523c1.294-1.183 3.928-.167 5.145.938A6.2 6.2 0 0 1 17.5 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wheat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWheat;
